<template>
  <div class="products-table-section" v-if="generatedTable">
    <div v-if="!showTableOnly">
      <h2>Details Table
        <v-btn icon fab>
          <v-icon dark @click="reloadReport()">refresh</v-icon>
        </v-btn>
      </h2>
      <div class="columns-visibility-toggle-container">
        <div class="btn-open-tbl-in-window">
        <!-- <v-btn
          dark
          class="open-in-window"
          color="indigo"
          elevation="3"
          id="open-summary-table-in-window"
          @click="triggerProductsTableWindowOpen">
          <i class="fas fa-external-link-alt open-tbl-btn"></i>
          <span> Open in new window</span>
        </v-btn> -->
        <v-btn
          dark
          class="open-in-window"
          color="indigo"
          elevation="3"
          id="open-summary-table-in-window">
          <download-excel :data="excelExportProductData">Download Excel</download-excel>
        </v-btn>
      </div>
      &ensp;
        <div class="toggles-header">
          <h3>Show/hide columns</h3>
          <button @click="toggleDetailsTogglesVisibility">
            <i v-if="detailsTogglesVisible" class="fa fa-angle-down toggles-visibility-control"></i>
            <i v-if="!detailsTogglesVisible" class="fa fa-angle-up toggles-visibility-control"></i>
          </button>
        </div>
        <div class="columns-visibility-toggle-list" v-if="detailsTogglesVisible">
          <div v-for="column in productsTableAvailableColumns" :key="column.field" class="column-visibility-toggle">
            <v-checkbox
              v-model="columnsVisibilityComputed"
              :value="column.field"
              class="m-0"
              color="teal"
              :label="column.name"
              density="compact"
              :disabled="column.immutable"
              hide-details
            ></v-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div>
      <v-data-table
        :headers="productsHeadersFiltered"
        :items="productsTableData"
        :sort-by="sortByField"
        :group-by="groupBy"
        :sort-desc="isSortDesc"
        :custom-sort="customSort"
        :search="productsSearch"
        :class="'elevation-2 ' + (isInWindowPortal ? 'my-1' : 'my-0')"
        :items-per-page="itemsPerPage"
        :loading="generatingTable"
        :height="isInWindowPortal ? null : 'auto'"
        :custom-filter="filterProducts"
        :custom-group="customGroup"
        :footer-props="{'items-per-page-options':[-1, 10, 20, 30, 50, 100]}"
        :item-class="getTableRowClass"
        caption="Products table"
        item-key="ProductID"
        loading-text="Loading... Please wait"
        ref="table"
        dense
        fixed-header
        show-group-by
        multi-sort
        @update:group-by="groupByUpdated"
      >
        <template
            v-slot:header
            v-if="!isInWindowPortal"
        >
          <tr>
            <th v-for="(hdr,index) in productsHeadersFiltered" :key="index">
                <v-text-field
                    :v-model="filtersProducts[`hdr.value`]"
                    v-on:change="changeProductsFilter($event, hdr)"
                    dense
                    hide-details
                    append-icon="fa-search"
                    solid
                    class="px-4"
                    clearable
                />
            </th>
          </tr>
        </template>
        <template v-slot:[`item.MarginPercent`]="props">
          <v-edit-dialog
            v-model:return-value="props.item.MarginPercent"
            @save="saveEditedRow(props.item, 'MarginPercent', props.index)"
            @cancel="cancelRowEdition"
            @open="openRowEditingSnack('marginpercent_text', props.item)"
            @close="closeRowEditingSnack()">
            <v-chip
              :color="(props.item.MarginPercent < 0) ? 'red' : ((props.item.IsPriceChanged) ? 'green' : 'transparent')"
              :dark="props.item.MarginPercent < 0"
              :ref="'marginpercent' + props.index">
              {{ markupFormatter(props.item.MarginPercent) }}
            </v-chip>
            <template v-slot:input v-if="!isInWindowPortal">
              <v-text-field
                @focus="$event.target.select()"
                label="Edit"
                single-line
                counter
                v-model.lazy="props.item.MarginPercent"
                :ref="'marginpercent_text'"
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:[`item.Selling${space}Price`]="props" v-if="!isInWindowPortal">
          <v-edit-dialog
            v-model:return-value="props.item[`Selling Price`]"
            @save="saveEditedRow(props.item, `Selling Price`, props.index)"
            @cancel="cancelRowEdition"
            @open="openRowEditingSnack('sellingprice_text', props.item)"
            @close="closeRowEditingSnack()">
          <v-chip
            :color="(props.item[`Selling Price`] < 0) ? 'red' : ((props.item.IsSellingPriceChanged) ? '' : 'transparent')"
            :dark="props.item[`Selling Price`] < 0"
            :ref="'sellingprice' + props.index"
          >
            {{ currencyFormatter(props.item[`Selling Price`]) }}
          </v-chip>
            <template v-slot:input>
              <v-text-field
                v-model="props.item[`Selling Price`]"
                @focus="$event.target.select()"
                :ref="'sellingprice_text'"
                label="Edit"
                single-line
                counter
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:[`item.Cost${space}Price`]="props" v-if="!isInWindowPortal">
          <v-edit-dialog
            v-model:return-value="props.item[`Cost Price`]"
            @save="saveEditedRow(props.item, `Cost Price`, props.index)"
            @cancel="cancelRowEdition"
            @open="openRowEditingSnack('costprice_text', props.item)"
            @close="closeRowEditingSnack()">
          <v-chip
            :color="(props.item[`Cost Price`] < 0) ? 'red' : ((props.item.IsCostPriceChanged) ? '' : 'transparent')"
            :dark="props.item[`Cost Price`] < 0"
            :ref="'costprice' + props.index"
            >
              {{ currencyFormatter(props.item[`Cost Price`]) }}
          </v-chip>
            <template v-slot:input>
              <v-text-field
                v-model="props.item[`Cost Price`]"
                @focus="$event.target.select()"
                :ref="'costprice_text'"
                label="Edit"
                single-line
                counter
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

        <template v-slot:[`item.ThisMonthSalesValues`]="props" >
          {{  currencyFormatter(props.item[`ThisMonthSalesValues`]) }}
        </template>
        <template v-slot:[`item.LastMonthSalesValues`]="props" >
          {{  currencyFormatter(props.item[`LastMonthSalesValues`]) }}
        </template>
        <template v-slot:[`item.MonthBeforeLastSalesValues`]="props" >
          {{  currencyFormatter(props.item[`MonthBeforeLastSalesValues`]) }}
        </template>
        <template v-slot:[`item.Last12MonthsSalesValues`]="props" >
          {{  currencyFormatter(props.item[`Last12MonthsSalesValues`]) }}
        </template>
        <template v-slot:[`group.summary`]="{ items }">
          <th :colspan="productsHdrsFilteredSetBeforeTotals.length">
             <span>
                Total products: {{ items.length }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('MarginPercent')">
             <span>
                MKUP Avg:<br> {{ markupFormatter(calcAvgMkup(items, 'Selling Price', 'Cost Price')) }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('ThisMonthSales')">
             <span>
                Total:<br> {{ calcSum(items, 'ThisMonthSales') }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('ThisMonthSalesValues')">
             <span>
                Total:<br> £{{ currencyFormatter(calcSum(items, 'ThisMonthSalesValues')) }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('LastMonthSales')">
             <span>
                Total:<br> {{ calcSum(items, 'LastMonthSales') }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('LastMonthSalesValues')">
             <span>
                Total:<br> £{{ currencyFormatter(calcSum(items, 'LastMonthSalesValues')) }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('MonthBeforeLastSales')">
             <span>
                Total:<br> {{ calcSum(items, 'MonthBeforeLastSales') }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('MonthBeforeLastSalesValues')">
             <span>
                Total:<br> £{{ currencyFormatter(calcSum(items, 'MonthBeforeLastSalesValues')) }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('Last12MonthsSales')">
             <span>
                Total:<br> {{ calcSum(items, 'Last12MonthsSales') }}
             </span>
          </th>
          <th v-show="productsHeadersFilteredValueSet.has('Last12MonthsSalesValues')">
             <span>
                Total:<br> £{{ currencyFormatter(calcSum(items, 'Last12MonthsSalesValues')) }}
             </span>
          </th>
          <th colspan="3"></th>
        </template>
        <template v-slot:[`body.append`]="{ groupedItems }">
          <tr class="v-table__summary" v-if="groupedItems">
            <th :colspan="productsHdrsFilteredSetBeforeTotals.length" class="title">
               <span>
                  Total products: {{ calcCountGroupedItems(groupedItems) }}<br>
               </span>
               <span>
                  Total groups: {{ groupedItems.length }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('MarginPercent')">
               <span>
                  {{ markupFormatter(calcAvgMkupGroupedItems(groupedItems, 'Selling Price', 'Cost Price')) }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('ThisMonthSales')">
               <span>
                  {{ calcSumGroupedItems(groupedItems, 'ThisMonthSales') }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('ThisMonthSalesValues')">
               <span>
                £{{ currencyFormatter(calcSumGroupedItems(groupedItems, 'ThisMonthSalesValues')) }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('LastMonthSales')">
               <span>
                  {{ calcSumGroupedItems(groupedItems, 'LastMonthSales') }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('LastMonthSalesValues')">
               <span>
                £{{ currencyFormatter(calcSumGroupedItems(groupedItems, 'LastMonthSalesValues')) }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('MonthBeforeLastSales')">
               <span>
                  {{ calcSumGroupedItems(groupedItems, 'MonthBeforeLastSales') }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('MonthBeforeLastSalesValues')">
               <span>
                £{{ currencyFormatter(calcSumGroupedItems(groupedItems, 'MonthBeforeLastSalesValues')) }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('Last12MonthsSales')">
               <span>
                  {{ calcSumGroupedItems(groupedItems, 'Last12MonthsSales') }}
               </span>
            </th>
            <th class="title" v-show="productsHeadersFilteredValueSet.has('Last12MonthsSalesValues')">
               <span>
                £{{ currencyFormatter(calcSumGroupedItems(groupedItems, 'Last12MonthsSalesValues')) }}
               </span>
            </th>
            <th colspan="3"></th>
          </tr>

          <tr class="v-table__summary" v-else>
            <!--
            <th class="title">
               <span>
                  Total items:<br> {{ totalsLineData['itemsCnt'] }}
               </span>
            </th>
            <th v-for="(header,i) in headers.slice(1)" :key="i" class="title">
                <span>{{ totalsLineData[header.value] }}</span><span v-if="header.value.endsWith('Margin')"></span><span v-else>£</span>
            </th>
            -->

            <th :colspan="productsHdrsFilteredSetBeforeTotals.length" class="title">
               <span>
                  Total products: {{ totalsLineData['itemsCnt'] }}<br>
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('MarginPercent')">
              <v-chip
                color="transparent"
              >
                {{ markupFormatter(totalsLineData['MarginPercent']) }}
              </v-chip>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('ThisMonthSales')">
               <span>
                  {{ totalsLineData['ThisMonthSales'] }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('ThisMonthSalesValues')">
               <span>
                £{{ currencyFormatter(totalsLineData['ThisMonthSalesValues'], true) }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('LastMonthSales')">
               <span>
                  {{ totalsLineData['LastMonthSales'] }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('LastMonthSalesValues')">
               <span>
                £{{ currencyFormatter(totalsLineData['LastMonthSalesValues'], true) }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('MonthBeforeLastSales')">
               <span>
                  {{ totalsLineData['MonthBeforeLastSales'] }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('MonthBeforeLastSalesValues')">
               <span>
                £{{ currencyFormatter(totalsLineData['MonthBeforeLastSalesValues'], true) }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('Last12MonthsSales')" >
               <span>
                  {{ totalsLineData['Last12MonthsSales'] }}
               </span>
            </th>
            <th class="text-right" v-show="productsHeadersFilteredValueSet.has('Last12MonthsSalesValues')" >
               <span>
                £{{ currencyFormatter(totalsLineData['Last12MonthsSalesValues'], true) }}
               </span>
            </th>
            <th colspan="3"></th>
          </tr>
        </template>

      </v-data-table>

      <v-snackbar
        v-model="snack"
        v-if="!isInWindowPortal"
        :timeout="3000"
        :color="snackColor"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
            v-bind="attrs"
            text
            @click="snack = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>

    <div v-if="generatedTable && !showTableOnly" class="products-table-bottom-controls">
      <div class="save-changes">
        <v-btn
          v-if="!savedChanges"
          id="save-changes-btn"
          color="success"
          class="px-10 bold"
          large
          @click="save()"
        >
          <span v-if="savingChanges">Saving..</span>
          <span v-if="!savingChanges && !savedChanges">Save</span>
        </v-btn>
        <span v-if="savedChanges">Saved changes</span>
        <span v-if="changesSavingError" id="save-changes-error" class="error-msg">
          Error saving changes
        </span>
        <div v-if="generatedUpdateEntityId" id="barcodes-page-link">
          <a :href="barcodesPageLink">Barcodes page link</a>
        </div>
      </div>
      <div class="scroll-up">
        <v-btn
          id="scroll-up-btn"
          class="mx-5 scroll-up-btn"
          fab
          width="47"
          height="47"
          elevation="6"
          @click="scrollUpProductsTable()"
        >
          <i class="fas fa-arrow-circle-up"></i>
        </v-btn>
      </div>
    </div>

    <vue-modal-2
      name="warning-entered-price"
      @on-close="$vm2.close('warning-entered-price')"
      :headerOptions="{
        title: 'Warning',
      }"
      noFooter
    >
      <div>
        <p>You've entered selling price less than cost price</p>
      </div>
    </vue-modal-2>

    <vue-modal-2
      name="warning-empty-changes"
      @on-close="$vm2.close('warning-empty-changes')"
      :headerOptions="{
        title: 'Warning',
      }"
      noFooter
    >
      <div>
        <p>No changes to save</p>
      </div>
    </vue-modal-2>

  </div>

</template>

<script>
import { mapState } from 'vuex';
import { groupItems, sortItems } from 'vuetify/es5/util/helpers';

import session from '../api/session';


export default {
  props: {
    isInWindowPortal: Boolean,
    columnSortFlag: Boolean,
  },
  data() {
    return {
      itemsPerPage: 50,
      sortByField: [],
      isSortDesc: [true],
      groupBy: [],
      space: ' ',
      snack: false,
      snackColor: '',
      snackText: '',
      marginTextField: '',
      currentPrice: '',
      filtersProducts: {
        Category: '',
        Supplier: '',
        currentValue: '',
        currentCol: '',
        ProductID: '',
        'Product Name': '',
        'Product Description': '',
        'Cost Price': '',
        'Selling Price': '',
        ThisMonthSales: '',
        MarginPercent: '',
        LastMonthSales: '',
      },
      columnsVisibility: [],
      changes: [],
      dbchanges: [],
      detailsTogglesVisible: false,
      copyableDataKeys: ['itemsPerPage', 'sortByField', 'isSortDesc', 'filtersProducts', 'columnsVisibility', 'detailsTogglesVisible'],
      totalsHdrs: ['MarginPercent', 'ThisMonthSales', 'ThisMonthSalesValues', 'LastMonthSales', 'LastMonthSalesValues', 'MonthBeforeLastSales', 'MonthBeforeLastSalesValues', 'Last12MonthsSales', 'Last12MonthsSalesValues'],
    };
  },
  computed: {
    ...mapState('products', [
      'excelExportProductData',
      'productsTableData',
      'generatingTable',
      'generatedTable',
      'tableGenerationError',
      'savingChanges',
      'savedChanges',
      'generatedUpdateEntityId',
      'changesSavingError',
      'categoriesForFilter',
      'suppliersForFilter',
      'productsDetailsTableWindowOpen'
    ]),
    barcodesPageLink() {return `/updated_products_barcodes/${this.generatedUpdateEntityId}`},
    productsTableAvailableColumns() {
      let columns = new Array();
      for (const hdr of this.productsHeaders) {
        const column = {
          name: hdr.text,
          field: hdr.value,
          immutable: false,
        }
        if (this.groupBy.includes(hdr.value)) {
          column.immutable = true;
        }
        columns.push(column);
      }
      return columns;
    },
    columnsVisibilityComputed: {
      get() {
        if (this.columnsVisibility.length === 0) {
          const visibility = [];
          for (const column of this.productsTableAvailableColumns) {
            if (!column.immutable) visibility.push(column.field);
          }
          return visibility;
        }
        if (this.columnSortFlagProperty) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.columnsVisibility = this.columnsVisibility.filter(e => this.productsTableAvailableColumns.find(x => x.field === e && x.immutable === false));
        }
        return this.columnsVisibility;
      },
      set(value) {
        this.columnsVisibility = value;
      },
    },
    columnSortFlagProperty: {
      get() {
        return this.columnSortFlag;
      },
      set(value) {
        // eslint-disable-next-line vue/no-mutating-props
        this.columnSortFlag = value;
      },
    },
    productsHeaders() {
      const hdrs = [
        { value: 'ProductID', text: 'Product ID', filterable: true, groupable: false, align: 'right'},
        { value: 'Product Name', text: 'Name', filterable: true, groupable: false, sortable: true },
        { value: 'Product Description', text: 'Description', filterable: true, groupable: false, },
        { value: 'Barcode', text: 'Barcode', filterable: true, groupable: false, align: 'right'},
        { value: 'Category Name', text: 'Category', filterable: true, groupable: true, sortable: true },
        { value: 'Supplier', text: 'Supplier', filterable: true, groupable: true, },
        { value: 'Cost Price', text: 'Cost Price (Ex VAT)', groupable: false, align: 'right'},
        { value: 'Selling Price', text: 'Selling Price (Inc VAT)', groupable: false, align: 'right'},
        { value: 'MarginPercent', text: 'Markup', groupable: false, align: 'right'},
        { value: 'ThisMonthSales', text: 'This month sales', groupable: false, align: 'right'},
        { value: 'ThisMonthSalesValues', text: 'This month sales Values', groupable: false, align: 'right' },
        { value: 'LastMonthSales', text: 'Last month sales', groupable: false, align: 'right' },
        { value: 'LastMonthSalesValues', text: 'Last month sales Values', groupable: false, align: 'right' },
        { value: 'MonthBeforeLastSales', text: 'Month pre last sales', groupable: false, align: 'right'},
        { value: 'MonthBeforeLastSalesValues', text: 'Month pre last sales Values', groupable: false, align: 'right'},
        { value: 'Last12MonthsSales', text: 'Last 12 Months Sales', groupable: false, align: 'right' },
        { value: 'Last12MonthsSalesValues', text: 'Last 12 Months Sales Values', groupable: false, align: 'right'},
        { value: 'Tax Percentage', text: 'Tax Percentage', groupable: false, align: 'right'},
        { value: 'Updated', text: 'Updated', groupable: false, },
        { value: 'RRP', text: 'RRP', groupable: false, align: 'right'},
      ]
      return hdrs;
    },
    productsHeadersFiltered() {
      let hdrs = [];
      this.productsHeaders.forEach((hdr) => {
        if (this.columnsVisibilityComputed.includes(hdr.value)) hdrs.push(hdr);
      })
      return hdrs;
    },
    productsHeadersFilteredValueSet() {
      let hdrs = new Set();
      this.productsHeadersFiltered.forEach((hdr) => {
        hdrs.add(hdr.value);
      })
      return hdrs;
    },
    productsHdrsFilteredSetBeforeTotals() {
      var ixOfFirstTotalHdr = null;
      this.productsHeadersFiltered.forEach((hdr, ix) => {
        if (ixOfFirstTotalHdr !== null) return;
        if (this.totalsHdrs.includes(hdr.value)) {
          ixOfFirstTotalHdr = ix;
          return;
        }
      })
      if (ixOfFirstTotalHdr === null) return [];
      return this.productsHeadersFiltered.slice(0, ixOfFirstTotalHdr);
    },
    productsSearch: {
      get() {
        return this.filtersProducts.currentValue;
      },
      set(value) {
        this.filters.filtersProducts = value;
      },
    },
    showTableOnly() {
      return (this.productsDetailsTableWindowOpen && this.isInWindowPortal);
    },
    totalsLineData() {
      let totals = {};
      const items = this.productsTableData;
      //const hdrsCnt = this.productsHeadersFiltered.length;
      const fields = ['MarginPercent', 'ThisMonthSales','ThisMonthSalesValues', 'LastMonthSales', 'LastMonthSalesValues', 'MonthBeforeLastSales','MonthBeforeLastSalesValues', 'Last12MonthsSales', 'Last12MonthsSalesValues'];
      const fieldsCnt = fields.length;
      for (let fieldIx=0; fieldIx < fieldsCnt; fieldIx++) {
        //const hdr = this.productsHeadersFiltered[fieldIx];
        const field = fields[fieldIx];
        let totalValue;
        if (field.startsWith('Margin')) {
          // calc avg markup
          var total = 0;
          var arrayLength = items.length;
          for (var i = 0; i < arrayLength; i++) {
              total += parseFloat(items[i][field]);
          }
          totalValue = parseFloat(total / items.length);
          //totalValue = (items.reduce((partialSum, item) => partialSum + item[field], 0) * 100) / items.length / 100;
        } else {
          // calc sum
          if (field.endsWith('Values')){
            totalValue = items.reduce((partialSum, item) => partialSum + item[field], 0);
          }
          else{
            totalValue = Math.round(items.reduce((partialSum, item) => partialSum + item[field], 0));
          }
        }
        totals[field] = totalValue;
      }
      totals['itemsCnt'] = items.length;
      return totals;
    },
  },
  methods: {
    getTableRowClass(item) {
      if (item === this.editingItem) {
        return 'changed-price';
      }
      else {
        return '';
      }
    },
    reloadReport() {
      this.$store.dispatch('products/generateTable', localStorage.getItem('selectedLocationId'));
    },
    save() {
      if (this.changes.length === 0) {this.$vm2.open('warning-empty-changes'); return};
      this.$store.dispatch('products/saveChanges', this.changes);
      this.changes.splice(0);
    },
    scrollUpProductsTable() {
      this.$refs.table.$el.scrollIntoView({behavior: 'smooth'});
    },
    filterProducts(value, search, item) {
      search = String(search);
      let nonEmptyFilterExists = false;

      for (let field in this.filtersProducts) {
        if (['currentValue', 'currentCol'].includes(field)) continue;
        const filterVal = String(this.filtersProducts[field]);
        if (filterVal === '' || filterVal === 'null') continue;
        const trueVal = String(item[field]);
        if (filterVal) {
          nonEmptyFilterExists = true;
          if (!trueVal.toLowerCase().includes(filterVal.toLowerCase())) return false;
        }
      }
      if (search && !nonEmptyFilterExists) return false;
      return true;
    },
    naturalCompare(a, b) {
      var ax = [], bx = [];

      a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || '']) });
      b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || '']) });

      while(ax.length && bx.length) {
          var an = ax.shift();
          var bn = bx.shift();
          var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
          if(nn) return nn;
      }

      return ax.length - bx.length;
    },
    sortingFunc(el1, el2) {
      let a = String(el1).trim().toLowerCase().split(' ').join('0');
      let b = String(el2).trim().toLowerCase().split(' ').join('0');
      return this.naturalCompare(b, a);
    },
    customSort(items, sortBy, sortDesc, locale, customSorters) {
      const sorters = {
        'Product Name': this.sortingFunc,
        'Category Name': this.sortingFunc,
        'Supplier': this.sortingFunc,
      }
      return sortItems(items, sortBy, sortDesc, locale, sorters);
    },
    changeProductsFilter(val, header) {
      this.filtersProducts[header.value] = val;
      this.filtersProducts.currentValue = val;
      this.filtersProducts.currentCol = header.value;
    },

    saveEditedRow(row, field, index) {
      this.snack = true;
      this.snackColor = 'success'
      this.snackText = 'Data saved'
      this.dbchanges = [];
      this.changedPrice = 0;
      if (['Selling Price', 'Cost Price'].includes(field)) {
        if (field === 'Selling Price'){
          this.changedPrice = row['Selling Price'];
          row.IsSellingPriceChanged = parseFloat(this.currentPrice) != parseFloat(this.changedPrice) ? true : false;
        }
        else{
          this.changedPrice = row['Cost Price'];
          row.IsCostPriceChanged = parseFloat(this.currentPrice) != parseFloat(this.changedPrice) ? true : false;
        }
        const sellingPrice = row['Selling Price'];
        const costPrice = row['Cost Price'];
        if (sellingPrice < costPrice) this.$vm2.open('warning-entered-price');
        let margin = (sellingPrice - costPrice) / costPrice;
        row.MarginPercent = isFinite(margin) ?  parseFloat(margin).toFixed(3)  : 0.000;
        this.changes.push({value: row[field], productId: row.ProductID, column: field});
        this.dbchanges.push({value: row[field], productId: row.ProductID, column: field, id: row.id});
      }
      else if (field === 'MarginPercent') {
        const costPrice = row['Cost Price'];
        const newSellingPrice = parseFloat(row['Cost Price']) * parseFloat(row.MarginPercent) + parseFloat(row['Cost Price'])
        row['Selling Price'] = this.currencyFormatter(newSellingPrice);
        this.changes.push({value: row['Selling Price'], productId: row.ProductID, column: 'Selling Price'});
        this.dbchanges.push({value: row['Selling Price'], productId: row.ProductID, column: 'Selling Price', id: row.id});
      }

      row.IsPriceChanged = parseFloat(this.currentPrice) !== parseFloat(this.changedPrice);
      field = field.replace(/\s+/g, '').toLowerCase();
      this.clickOnNextEdit(field, index);
      if(parseFloat(this.currentPrice) != parseFloat(this.changedPrice)){
        this.$store.dispatch('products/saveProductChanges', this.dbchanges);
      }
      this.editingItem= null
    },

    cancelRowEdition() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
      this.editingItem= null
    },

    openRowEditingSnack(field, item) {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
      this.editingItem = item;
      switch(field){
        case 'costprice_text':
        this.currentPrice = item['Cost Price'];
        break;
        case 'sellingprice_text':
        this.currentPrice = item['Selling Price'];
        break;
        default:
        this.currentPrice = item['MarginPercent'];
        break;
      }
      setTimeout(() => this.$refs[field] != undefined ? this.$refs[field].focus() : '', 500);
      this.marginTextField = item['MarginPercent'];
    },

    closeRowEditingSnack() {
      this.snack = false;
    },

    triggerProductsTableWindowOpen() {
      if (this.productsDetailsTableWindowOpen) {
        this.$store.dispatch('products/closeDetailsTableWindow');
        setTimeout(() => this.$store.dispatch('products/openDetailsTableInWindow'), 1000)
      } else {
        this.$store.dispatch('products/openDetailsTableInWindow');
      }
    },
    toggleDetailsTogglesVisibility() {
      this.detailsTogglesVisible = !this.detailsTogglesVisible;
    },
    calcCountGroupedItems(groupedItems) {
      return groupedItems.reduce((partialSum, group) => partialSum + group.items.length, 0);
    },
    calcSum(items, field) {
      return items.reduce((partialSum, item) => partialSum + item[field], 0);
    },
    calcSumGroupedItems(groupedItems, field) {
      return groupedItems.reduce((partialSum, group) => partialSum + this.calcSum(group.items, field), 0);
    },
    calcAvgMkup(items, sellingField, costField) {
      /* let totalCostPrice = 0;
      items.forEach(function (obj) {
            if( obj.hasOwnProperty(costField)  && obj.hasOwnProperty(itemCount)) {
              totalCostPrice += parseFloat(obj[costField]) * parseFloat(obj[itemCount])  ;
            }
          });
          if(Math.round(totalCostPrice) == 0) return 0;
          let totalSellingPrice = 0;
          items.forEach(function (obj) {
            if( obj.hasOwnProperty(sellingField)  && obj.hasOwnProperty(itemCount)) {
              totalSellingPrice += parseFloat(obj[sellingField]) * parseFloat(obj[itemCount])  ;
            }
          });
           */
      let totalCostPrice = (items.reduce((partialSum, item) => partialSum + (parseFloat(item[costField])), 0));
      if(Math.round(totalCostPrice) == 0) return 0;
      let totalSellingPrice = (items.reduce((partialSum, item) => partialSum + parseFloat(item[sellingField]), 0));
      return (totalSellingPrice - totalCostPrice) / totalCostPrice;
      //return Math.round((items.reduce((partialSum, item) => partialSum + item[field], 0) * 100) / items.length) / 100;
    },
    calcAvgMkupGroupedItems(groupedItems, sellingField, costField) {
      return Math.round((groupedItems.reduce((partialSum, group) => partialSum + this.calcAvgMkup(group.items, sellingField, costField), 0) * 100) / groupedItems.length) / 100;
    },
    customGroup(items, groupBy, groupDesc) {
      this.itemsPerPage = -1;
      let table = this.$refs.table;

      const inversedGroupDesc = [...groupDesc].map((el) => !el);

      const newSortBy = [...groupBy, ...table.sortBy];
      const newSortDesc = [...inversedGroupDesc, ...table.sortDesc];
      const curItems = this.customSort([...this.productsTableData], newSortBy, newSortDesc)

      const groupedItems = groupItems(curItems, groupBy, inversedGroupDesc);

      let keys = Object.keys(table.$vnode.componentInstance.openCache);
      //keys.pop() //remove last element so that first group stays open
      keys.forEach(x => {
          table.$vnode.componentInstance.openCache[x] = false;
          //table.openCache[x] = false;
      });
      this.itemsPerPage = 50;
      return groupedItems;
    },
    groupByUpdated(newGroupBy) {
      /*
      if (newGroupBy.length === 0) {
        this.itemsPerPage = 50;
      }*/
      this.itemsPerPage = 50;
      this.columnSortFlagProperty = true;
    },
    currencyFormatter(value, formatRequired = false){
      if(formatRequired)
      {
        return parseFloat(value.toFixed(3)).toLocaleString();
      }
      return parseFloat(value).toFixed(3);
    },
    markupFormatter(value, formatRequired = false){
      if(formatRequired)
      {
        return Number(parseFloat(value)).toFixed(3).toLocaleString();
      }
      return parseFloat(value).toFixed(3);
    },
    clickOnNextEdit(field, index) {
      this.$nextTick(() => {
        const editButtonRef = this.$refs[field + (index + 1)];
        if(editButtonRef != undefined){
            editButtonRef.$el.click();
        }
      });
    }
  },
};

</script>


<style>

.products-table-bottom-controls {
  margin-top: 25px;
  display: flex;
  align-items: center;
}

#home-view .save-changes {
  display: flex;
  align-items: center;
}

#barcodes-page-link {
  margin-left: 25px;
}

.products-table {
  height: 1305px;
}

.products-table-total-rows {
  text-align: right;
  margin-top: 27px;
}

/*
#home-view .summary-report-cols-visibility-toggles-container .column-visibility-toggle {
  width: auto;
}
*/

/*
.column-visibility-toggle .v-input__slot {
  display: flex;
  align-items: flex-start;
}
*/

/*
.columns-visibility-toggle-list label {
  white-space: nowrap;
}
*/

.vm2_wrapper {
  z-index: 10;
}

.vm2_body {
  text-align: center;
}

.vm2__hr {
  margin-bottom: 0;
}


.open-tbl-btn {
  font-size: 13pt;
}

.scroll-up-btn i {
  font-size: 19pt;
}

/*
.products-table-section h2 {
  margin-bottom: 0;
  line-height: 1;
}
*/

/*
.v-row-group__header, .v-row-group__header td, .v-row-group__summary, .v-row-group__summary th {
  text-align: left;
  max-height: 38px !important;
  height: 38px !important;
  min-height: 10px !important;
}
*/

.products-table-section .v-data-table td, .products-table-section .v-data-table tr, .products-table-section .v-data-table th {
  max-height: 38px !important;
  height: 38px !important;
  min-height: 10px !important;
}

.products-table-section .v-table__summary th span {
  font-size: 12pt !important;
}

.products-table-section .v-row-group__summary th {
  border-bottom: 1px solid rgba(0,0,0,0.5) !important;
}

.products-table-section .v-data-table__wrapper {
  max-height: 1000px;
}

.products-table-section .v-table__summary th {
  border-top: 1px solid rgba(0,0,0,0.9) !important;
  line-height: 1.15;
}

.products-table-section .v-data-table .v-table__summary {
  height: 60px !important;
  position: sticky;
  bottom: 0;
  background: #fff;
}

.v-table__summary th {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}

.changed-price {
  background-color: #ffa;
}

</style>



// WEBPACK FOOTER //
// src/components/DetailsTable.vue